import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// functions
import * as ComponentFunctions from './ProtocolHeader.Functions';

// Styles
import './ProtocolHeader.Styles.css';


export const ProtocolHeaderComponent = (props: ComponentFunctions.Props) => {

    const [t] = useTranslation();

    useEffect(() => {
        if (props.ProtocolId) {
            props.GetMedicalProtocolById(props.ProtocolId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.ProtocolId]);

    const statusId = props.Protocol?.status?.id;
    const statusClass = `status-${ComponentFunctions.GetProtocolStatusClass(statusId).toLowerCase().replace(/\s+/g, '-') || 'none'}`;
    const statusText = ComponentFunctions.GetProtocolStatusDescripcion(statusId);

    return (
        <div className={`protocolHeader ${statusClass}`}>
            <div className="protocolHeader-titleBlock">
                <span className="protocolHeader-title">{props.Protocol?.title || '—'}</span>
                {props.Protocol?.fullTitle && (
                    <span className="protocolHeader-subtitle" title={props.Protocol.fullTitle}>
                        {props.Protocol.fullTitle}
                    </span>
                )}
            </div>

            <div className="protocolHeader-divider" aria-hidden="true" />

            <div className="protocolHeader-meta">
                <div className="protocolHeader-metaItem">
                    <span className="protocolHeader-eyebrow">{t('protocolHeader.details.phase')}</span>
                    <span className="protocolHeader-metaValue">{props.Protocol?.phase?.title || '—'}</span>
                </div>
                <div className="protocolHeader-metaItem">
                    <span className="protocolHeader-eyebrow">{t('protocolHeader.details.specialty')}</span>
                    <span className="protocolHeader-metaValue">{props.Protocol?.specialty?.description || '—'}</span>
                </div>
            </div>

            <span className={`protocolHeader-statusPill ${statusClass}`} title={t('protocolHeader.details.status')}>
                {statusText}
            </span>
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ProtocolHeaderComponent as any);
